var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 56,
    viewBox: "0 0 70 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.9997 55.3332H0.833008V48.4998H20.4788C17.9847 38.899 10.4338 31.3823 0.833008 28.8882C3.01967 28.3415 5.30884 27.9998 7.66634 27.9998C22.768 27.9998 34.9997 40.2315 34.9997 55.3332ZM69.1663 28.8882C66.9797 28.3415 64.6905 27.9998 62.333 27.9998C52.3222 27.9998 43.6097 33.3982 38.8263 41.4273C39.8172 43.6823 40.6372 46.0398 41.1155 48.4998C41.5597 50.7207 41.7988 53.0098 41.7988 55.3332H48.6322H69.1322V48.4998H49.4863C52.0147 38.899 59.5655 31.3823 69.1663 28.8882ZM47.4363 24.6515C50.1013 17.5107 55.0555 11.5315 61.4105 7.56817C46.753 8.0465 34.9997 20.039 34.9997 34.8332C34.9997 34.8673 34.9997 34.9015 34.9997 34.9015C38.2455 30.5623 42.5163 27.0432 47.4363 24.6515ZM33.018 17.2373C30.148 9.75484 24.3397 3.70734 16.8913 0.666504C21.8113 7.0215 24.7497 14.9482 24.7497 23.5923C24.7497 24.3098 24.6472 24.9932 24.613 25.6765C26.0822 26.4965 27.4488 27.4532 28.7813 28.4782C29.4988 24.4465 31.0022 20.654 33.018 17.2373Z",
    fill: "#323232"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.b54f0466369c158b220d84b9ed2cc5c4.svg";
export { ForwardRef as ReactComponent };